import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../querykeys";
import { getCurrentUserAPI } from "./getCurrentUser.api";

export const useGetCurrentUserQuery = (enabled: boolean = true) => {
  return useQuery({
    queryKey: QUERY_KEYS.CURRENT_USER_DETAILS,
    queryFn: getCurrentUserAPI,
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 1,
  });
};

